export const resumeEmails = state => state.resumeEmails;



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/optionEmails/getters.js
 **/